import React from "react";
import { Checkbox } from "@pd/pd-ui-kit";
import { ColumnsType } from "antd/es/table";
import type { SortOrder } from "antd/es/table/interface";
import { TFunction } from "i18next";

import { RequisiteIProps } from "~/entity/AvtovazRequisites";

/** Колонки таблицы реквизитов, по которым возможна клиентская сортировка */
export const REQUISITES_SORTABLE_COLUMNS = [
  "companyName",
  "fullCompanyName",
  "inn",
  "ogrn",
  "bankName",
  "bik",
  "email",
  "phone",
  "active",
];

const localeCompare = (a: unknown, b: unknown) =>
  String(a ?? "").localeCompare(String(b ?? ""));

const COMPARATORS: Record<
  string,
  (a: RequisiteIProps, b: RequisiteIProps) => number
> = {
  companyName: (a, b) => localeCompare(a.companyName, b.companyName),
  fullCompanyName: (a, b) =>
    localeCompare(a.fullCompanyName, b.fullCompanyName),
  inn: (a, b) => localeCompare(a.inn, b.inn),
  ogrn: (a, b) => localeCompare(a.ogrn, b.ogrn),
  bankName: (a, b) => localeCompare(a.bankName, b.bankName),
  bik: (a, b) => localeCompare(a.bik, b.bik),
  email: (a, b) => localeCompare(a.email, b.email),
  phone: (a, b) => localeCompare(a.phone, b.phone),
  active: (a, b) => Number(Boolean(a.active)) - Number(Boolean(b.active)),
};

export const getRequisitesColumns = (
  options: string[],
  onToggleActive: (record: RequisiteIProps) => void | Promise<void>,
  pendingToggleId: number | null,
  t: TFunction,
  sortField?: string,
  sortType?: string,
): ColumnsType<any> =>
  options
    .filter((option) => option !== "icons")
    .map((option) => {
      const comparator = COMPARATORS[option];
      const sortOrder: SortOrder | undefined =
        comparator &&
        sortField === option &&
        (sortType === "ASC" || sortType === "DESC")
          ? sortType === "DESC"
            ? "descend"
            : "ascend"
          : undefined;

      const baseColumn = {
        title: t(`listRequisites.${option}`),
        dataIndex: option,
        key: option,
        ...(comparator ? { sorter: comparator, sortOrder } : {}),
      };

      // Special render for active field - checkbox
      if (option === "active") {
        return {
          ...baseColumn,
          render: (value: any, record: RequisiteIProps) => {
            const isBusy = pendingToggleId !== null;
            return (
              <Checkbox
                checked={Boolean(value)}
                disabled={isBusy}
                onChange={() => onToggleActive(record)}
              />
            );
          },
        };
      }

      return {
        ...baseColumn,
        render: (value: any) => <span>{value}</span>,
      };
    });
